module.exports = __webpack_public_path__ + "img/tsumugiModal.048c0f22.png";